var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"f_box"},[_c('iframe',{ref:"iframe",staticClass:"iframe_box",attrs:{"src":this.$store.state.global_url,"frameborder":"0","scolling":"no"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }